import * as types from './types';
import { createAction } from 'redux-actions';

export const logout = createAction(types.LOGOUT);

// LOGIN
export const login = createAction(types.LOGIN);
export const autologin = createAction(types.AUTOLOGIN);
export const loginProcess = createAction(types.LOGIN_PROCESS);
export const loginSuccess = createAction(types.LOGIN_SUCCESS);
export const loginError = createAction(types.LOGIN_ERROR);

// REGISTER
export const register = createAction(types.REGISTER);
export const registerProcess = createAction(types.REGISTER_PROCESS);
export const registerSuccess = createAction(types.REGISTER_SUCCESS);
export const registerError = createAction(types.REGISTER_ERROR);

// fetch user
export const fetchUser = createAction(types.FETCH_USER);
export const fetchUserProcess = createAction(types.FETCH_USER_PROCESS);
export const fetchUserError = createAction(types.FETCH_USER_ERROR);
export const fetchUserSuccess = createAction(types.FETCH_USER_SUCCESS);

// reset password
export const resetPassword = createAction(types.RESET_PASSWORD);
export const resetPasswordProcess = createAction(types.RESET_PASSWORD_PROCESS);
export const resetPasswordError = createAction(types.RESET_PASSWORD_ERROR);
export const resetPasswordSuccess = createAction(types.RESET_PASSWORD_SUCCESS);

// forgot password
export const forgotPassword = createAction(types.FORGOT_PASSWORD);
export const forgotPasswordProcess = createAction(types.FORGOT_PASSWORD_PROCESS);
export const forgotPasswordError = createAction(types.FORGOT_PASSWORD_ERROR);
export const forgotPasswordSuccess = createAction(types.FORGOT_PASSWORD_SUCCESS);

// Patch user
export const patchUser = createAction(types.PATCH_USER);
export const patchUserProcess = createAction(types.PATCH_USER_PROCESS);
export const patchUserError = createAction(types.PATCH_USER_ERROR);
export const patchUserSuccess = createAction(types.PATCH_USER_SUCCESS);

// reset password
export const reinitPassword = createAction(types.REINIT_PASSWORD);
export const reinitPasswordProcess = createAction(types.REINIT_PASSWORD_PROCESS);
export const reinitPasswordError = createAction(types.REINIT_PASSWORD_ERROR);
export const reinitPasswordSuccess = createAction(types.REINIT_PASSWORD_SUCCESS);

export const refreshAuthToken = createAction(types.REFRESH_TOKEN);